import React from "react";
import ButtonGroupNavigation from "components/button_group_navigation";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Switch, Route } from "react-router-dom";
import Sales from "./Sales";

import CoreExchanges from "./CoreExchanges";



const useStyles = makeStyles(theme => ({
    subNavigation: {
        margin: '2% 3%',
        width: '85%',
    }
}));


export default function PartSales(props) {

    const classes = useStyles();
    const buttons = [

        { name: "Sales", redirect: '/org/accounts/part_sales/sales' },
        { name: "Core Exchange", redirect: '/org/accounts/part_sales/core' },

    ]
    return (
        <div>
            <div className={classes.subNavigation}>
                <ButtonGroupNavigation buttons={buttons} {...props} />
            </div>
            <Switch>
                <Route exact path={'/org/accounts/part_sales/sales'} component={rprops => <Sales {...rprops} {...props} permission={props?.permission} />} />
                <Route exact path={'/org/accounts/part_sales/core'} component={rprops => <CoreExchanges {...rprops} {...props} permission={props?.permission} />} />
                <Route component={Sales} />
            </Switch>

        </div>
    )
}




